export default __webpack_public_path__ + "static/aws-logo-25380ac022a51a5b331f33dee1f30d87.png";